export default __webpack_public_path__ + "static/media/spotify.a888ae5f.svg";